import type { CSSProperties } from 'react';

export interface TabItem {
  id: string;
  label: string;
  count?: number;
}

export interface TabsProps {
  tabs: TabItem[];
  value: string;
  onChange: (id: string) => void;
  style?: CSSProperties;
}

export function Tabs({ tabs, value, onChange, style }: TabsProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 4,
        borderBottom: '1px solid var(--apm-line)',
        // Scroll horizontally rather than overflow/wrap when there are more
        // tabs than fit — keeps the strip on one clean line at any width.
        overflowX: 'auto',
        scrollbarWidth: 'none',
        ...style,
      }}
    >
      {tabs.map((t) => {
        const active = t.id === value;
        return (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '10px 14px',
              fontFamily: 'var(--apm-font-body)',
              fontSize: 13.5,
              fontWeight: active ? 600 : 500,
              color: active ? 'var(--apm-ink)' : 'var(--apm-muted)',
              borderBottom: active
                ? '2px solid var(--apm-ink)'
                : '2px solid transparent',
              marginBottom: -1,
              cursor: 'pointer',
              letterSpacing: '0.01em',
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}
          >
            {t.label}
            {t.count != null && (
              <span
                style={{
                  marginLeft: 6,
                  color: 'var(--apm-muted-2)',
                  fontWeight: 400,
                }}
              >
                {t.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
